import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faShieldHalved } from "@fortawesome/free-solid-svg-icons";

const Section1 = ({url}) => {
  const dashboardImage =
    "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=1200&q=80";

  return (
    <section className="home-section-1 d-flex align-items-center text-center"
    
        style={{
        // backgroundImage: `url("https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe")`,
        backgroundImage: `url("${url}images/concord/background.png")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
    }}
    >
      <div className="container">

        <img src={`${url}images/concord/logo.png`} alt="Hero Image" />
        <h1 className="hero-title" data-aos="fade-up">
          Stop Managing Documents <br />
          <h2 className="gradient-text">Start Intelligently Controlling Them.</h2>
        </h1>

        <p className="hero-subtitle mt-3" data-aos="fade-up" data-aos-delay="200">
         AI document management system to give every user exactly what they're authorized to see, retrieved instantly, collaborated securely, and audited automatically.
        </p>

        <button
          className="btn btn-gradient mt-4"
          data-aos="zoom-in"
          data-aos-delay="400"
        >
          See Concord in Action
        </button>

      </div>
      <div className="hero-images" data-aos="fade-up" data-aos-delay="400">
        <img src={`${url}images/concord/laptop.png`} alt="" />
      </div>
      {/* <div style={{ width: "100%" }}>
        <img src={`${url}images/omnix/banner-inner.png`} alt="" />
      </div> */}
    </section>
  );
};

export default Section1;
